import { PropsWithChildren } from 'react'
import { PanelGroup as PanelGroupComponent } from 'react-resizable-panels'

export const PanelGroup = (props: PropsWithChildren) => {
    return <PanelGroupComponent direction="horizontal">{props.children}</PanelGroupComponent>
}
